import React, { useRef, useState } from "react";
import Select from "react-select";
import Flatpicker from "react-flatpickr";
// import moment from "moment";
import calendarIcon from "../img/calendarcalendar-icon.svg";
import searchIcon from "../img/search.svg";
import chevronDown from "../img/chevronDown.svg";
import chevronUp from "../img/chevronUp.svg";
import flagIcon from "../img/NGflag-select.svg";
// import ReactPhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
import { NumericFormat, PatternFormatProps } from "react-number-format";
import { PatternFormat } from "react-number-format";
import ProgressBar from "../progressBar/ProgressBar";
// import { ColorRing } from "react-loader-spinner";
import ReactPinField from "react-pin-field";
import { FileUploader } from "react-drag-drop-files";
import Countdown from "../helper/coutdown";
import { useEffect } from "react";
import uploadGeneralImg from "../img/general-upload.png";
import pdfIcon from "../img/pdf-icon.webp";
import "flatpickr/dist/themes/airbnb.css";
// import PhoneInput from "react-phone-input-2";
import { RazorInputProps } from "../types";
import { FaCheck } from "react-icons/fa";

import {
  detectCard,
  formatCard,
  handleCvvChange,
  handleExpiryDateChange,
} from "../helper/helper";
import { icons } from "../icons/icons";
import PhoneNumberInput from "../RazorPhoneInput";

// currency converter types

interface PatternFormat extends PatternFormatProps {
  className?: string;
  decimalScale?: any | undefined;
  decimalSeparator?: string;
  disabled?: boolean;
  type?: "text";
  placeholder?: string;
  id?: any;
  onChange?: any;
  value?: any;
  name?: string;
}

const trimLongString = (str: string, num: number) => {
  const val =
    String(str).length > Number(num)
      ? `${String(str).slice(0, Number(num))}...`
      : str;
  return val;
};

// end of converter types

const reactSelectStyleTable = {
  control: (base: any, state: any) => ({
    ...base,
    border: state.isFocused ? "0.1rem solid #6F6F6F" : "0.1rem solid #6F6F6F",
    // backgroundColor: state.isSelected ? "#6F6F6F" : "white",
    boxShadow: state.isFocused ? "0.1rem solid #6F6F6F" : 0,
    "&:hover": {
      // border: state.isFocused ? 0 : 0
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#734792" : "white",
  }),
};

const RazorInputField = ({
  textColor,
  labelClassName,
  labelColor,
  labelSpanText,
  color,
  value,
  name,
  id,
  className,
  style,
  label,
  type,
  onChange,
  placeholder,
  errorText,
  showError,
  selectOption,
  selectStyles,
  selectValue,
  disabled,
  loading,
  searchable,
  isClearable,
  maxLength,
  multi,
  selectClassName,
  textareaColumn,
  textareaRow,
  numberPrefix,
  showColor,
  onActionClick,
  showPasswordStrength,
  onSubmit,
  onComplete,
  pinFieldNumber,
  countDownTime,
  showCountDown,
  thousandFormat,
  onSizeError,
  maxSize,
  onRemoveFile,
  enableTime,
  selectMenuOpen,
  showValue,
  min,
  max,
  menuPlacement,
  pinId,
  pinRef,
  uploadSpan,
  upploadText,
  scheduleFormat,
  loadingSelect,
  // maxLength,
  dateOptions,
  minuteIncrement,
  purpleGradient,
  additionalValue,
  numberUp,
  numberDown,
  range,
  numberSpinner,
  rangeStep,
  countdownFinishClick,
  countdownFinishText,
  countdownFinishClassName,
  countdownFinishTextClassName,
  countdownLabelClassName,
  selectComponents,
  onKeyUp,
  onKeyDown,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
  onMouseMove,
  onMouseOver,
  onMouseUp,
  onMouseOut,
  loaderText,
  // loaderColor,
  readOnly,
  removeAutoComplete,
  strengthColor,
  onInputFocus,
  onInputBlur,
  capitalize,
  numberSuffix,
  inputPattern,
  onMenuOpen,
  inputMode,
  customPreviewSrc,
  customPreviewName,
  customPreviewSize,
  formatOptionLabel,
  ...props
}: RazorInputProps) => {
  const [showPasword, setShowPassword] = useState(false);
  const [completePin, setCompletePin] = useState(false);
  const [file, setFile] = useState<any>("");
  // require(`flatpickr/dist/themes/${color?.split('-')[1] === 'dark' ? 'dark' : 'airbnb'}.css`)

  const sumAllNum = (list: number[]) => {
    if (list) {
      const sumVal = list?.reduce((a, b) => a + b, 0);
      return sumVal;
    }
    return;
  };

  {
    /* check drop box end */
  }

  const [showGuessBox, setShowGuessBox] = useState(false);

  const [rangeValue, setRange] = useState(0);
  const [cardType, setCardType] = React.useState("");
  const handleRangeChange = (event: any) => {
    setRange(event.target.value);
    onChange(event);
  };

  function formatSizeUnits(bytes: any) {
    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + " GB";
    } else if (bytes >= 1048576) {
      bytes = (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      bytes = (bytes / 1024).toFixed(2) + " KB";
    } else if (bytes > 1) {
      bytes = bytes + " bytes";
    } else if (bytes === 1) {
      bytes = bytes + " byte";
    } else {
      bytes = "0 bytes";
    }
    return bytes;
  }

  function rangeStyle() {
    const styledRanges = document.getElementsByClassName("styled_range");
    for (let i = 0; i < styledRanges.length; i++) {
      let thumbRange: any = null,
        trackRange: any = null;
      for (let j = 0; j < styledRanges[i].children.length; j++) {
        const child = styledRanges[i].children[j];
        if (child.className === "thumb_range") thumbRange = child;
        else if (child.className === "track_range") trackRange = child;
      }
      thumbRange.oninput = (function (thumbRange, trackRange) {
        return function () {
          trackRange.value = thumbRange.value;
        };
      })(thumbRange, trackRange);
    }
  }

  useEffect(() => {
    rangeStyle();
  }, [range]);

  const defaultRef: any = useRef();
  const [validate, setValidate] = useState({
    hasLow: 0,
    hasCap: 0,
    hasNumber: 0,
    has8digit: 0,
    hasSpecial: 0,
  });

  const validatePassword = (password: any) => {
    if (password.match(/\d+/g)) {
      setValidate((o) => ({ ...o, hasNumber: 20 }));
    } else {
      setValidate((o) => ({ ...o, hasNumber: 0 }));
    }
    if (password.match(/[!@#$%^.&*_=+-]/g)) {
      setValidate((o) => ({ ...o, hasSpecial: 20 }));
    } else {
      setValidate((o) => ({ ...o, hasSpecial: 0 }));
    }

    if (password.match(/[A-Z]+/g)) {
      setValidate((o) => ({ ...o, hasCap: 20 }));
    } else {
      setValidate((o) => ({ ...o, hasCap: 0 }));
    }

    if (password.match(/[a-z]+/g)) {
      setValidate((o) => ({ ...o, hasLow: 20 }));
    } else {
      setValidate((o) => ({ ...o, hasLow: 0 }));
    }

    if (password.length > 7) {
      setValidate((o) => ({ ...o, has8digit: 20 }));
    } else {
      setValidate((o) => ({ ...o, has8digit: 0 }));
    }
  };

  function sumValue(a: any, b: any, c: any, d: any, e: any) {
    const sum = a + b + c + d + e;
    return sum;
  }

  if (type === "upload-two") {
    return (
      <div className={`form-group form-group__${color} ${className}`}>
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {/* {!file && ( */}
        <div
          className={`input-group upload-group ${file && "upload-group-show"}`}
        >
          <FileUploader
            handleChange={(e: any) => {
              setFile(e);
              onChange?.(e);
            }}
            name="file"
            disabled={disabled}
            // onKeyDown={onKeyDown}
            // onKeyUp={onKeyUp}
            // onMouseEnter={onMouseEnter}
            // onMouseLeave={onMouseLeave}
            hoverTitle={"drop here"}
            onSizeError={onSizeError}
            maxSize={maxSize}
            // types={fileTypes}
          >
            <p className="upload-text">
              <span
                className={
                  labelColor ? `text-${labelColor}` : `text-purple-light`
                }
              >
                {uploadSpan || "Click to upload"}
              </span>{" "}
              {upploadText || " or drag and  drop image file here"}
            </p>
          </FileUploader>
        </div>
        {/* )} */}
        {/* {file && ( */}
        {/* )} */}
      </div>
    );
  }
  const todayDate = new Date();
  if (type === "upload") {
    if (customPreviewSrc) {
      return (
        <div className={`form-group form-group__${color} ${className}`}>
          <div className={`display-wrap  display-wrap-show`}>
            <div className="display-box">
              <figure className="img-box">
                <img src={customPreviewSrc as string} alt="" className="img" />
              </figure>
              <div className="text-box">
                <p className="name">
                  {trimLongString(customPreviewName || "Image", 25)}
                </p>
                <p className="size">
                  {formatSizeUnits(customPreviewSize || "5000")}
                </p>
              </div>
              <div
                onClick={() => {
                  setFile("");
                  onRemoveFile?.();
                }}
                className="cancel-box"
              >
                <svg
                  className="icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                >
                  <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      );
    } else
      return (
        <div className={`form-group form-group__${color} ${className}`}>
          {label && (
            <label htmlFor="" className="form-label">
              {label}{" "}
              {labelSpanText && (
                <span
                  onClick={onActionClick}
                  className={`label-span text-${labelColor} ${labelClassName}`}
                >
                  {labelSpanText}
                </span>
              )}
            </label>
          )}
          {!file ? (
            <div
              style={{ padding: "1rem" }}
              className={`input-group upload-group ${
                file && "upload-group-show"
              }`}
            >
              <FileUploader
                handleChange={(e: any) => {
                  setFile(e);
                  onChange?.(e);
                }}
                name="file"
                disabled={disabled}
                // onKeyDown={onKeyDown}
                // onKeyUp={onKeyUp}
                // onMouseEnter={onMouseEnter}
                // onMouseLeave={onMouseLeave}
                hoverTitle={"drop here"}
                onSizeError={onSizeError}
                maxSize={maxSize}
                // types={fileTypes}
              >
                <p className="upload-text">
                  <span
                    className={
                      labelColor ? `text-${labelColor}` : `text-purple-light`
                    }
                  >
                    {uploadSpan || "Click to upload"}
                  </span>{" "}
                  {upploadText || " or drag and  drop image file here"}
                </p>
              </FileUploader>
            </div>
          ) : (
            <div className={`display-wrap ${file && "display-wrap-show"}`}>
              <div className="display-box">
                <figure className="img-box">
                  {file.type.includes("image/") ? (
                    <img
                      src={file && URL.createObjectURL(file)}
                      alt=""
                      className="img"
                    />
                  ) : file.type === "application/pdf" ? (
                    <img src={file && pdfIcon} alt="" className="img" />
                  ) : (
                    <img
                      src={file && uploadGeneralImg}
                      alt=""
                      className="img"
                    />
                  )}
                </figure>
                <div className="text-box">
                  <p className="name">{trimLongString(file?.name, 25)}</p>
                  <p className="size">{formatSizeUnits(file?.size)}</p>
                </div>
                <div
                  onClick={() => {
                    setFile("");
                    onRemoveFile?.();
                  }}
                  className="cancel-box"
                >
                  <svg
                    className="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 352 512"
                  >
                    <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
      );
  }

  if (type === "submit") {
    return (
      <div className={`form-group form-group__${color}  ${className} `}>
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {loading ? (
          <div
            className={`input-submit input-submit-loading  text-${textColor} ${
              disabled && "input-submit_disabled"
            }`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: ".5rem",
              padding: ".5rem 0rem",
            }}
          >
            {" "}
            <div
              className="loader-wrap"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.8rem",
                justifyContent: "center",
              }}
            >
              {loaderText && <p>{loaderText}</p>}
              <div className="spin">
                {" "}
                <p
                  className={`spintula spintula-arc-${color || "green-light"}`}
                ></p>
              </div>

              {/* <ColorRing
                visible={true}
                height={"35"}
                width={"35"}
                ariaLabel="blocks-loading"
                wrapperClass="blocks-wrapper"
                colors={[
                  "#ffffff99",
                  "#ffffff99",
                  "#ffffff99",
                  "#ffffff99",
                  "#ffffff99",
                ]}
              /> */}
            </div>
          </div>
        ) : (
          <input
            type="submit"
            autoComplete={!removeAutoComplete ? "off" : ""}
            role="presentation"
            readOnly
            value={value}
            onClick={onSubmit}
            className={`input-submit  text-${textColor} ${
              purpleGradient && "btn_purple_gradient"
            } ${disabled && "input-submit_disabled"}`}
            disabled={disabled}
          />
        )}
      </div>
    );
  }

  if (type === "pin") {
    return (
      <div
        style={style}
        className={`form-group form-group__${
          color ? color : "black-light"
        } ${className}`}
      >
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {/* pin group start */}
        <div className={`pin-group pin-group_${color}`}>
          <div
            style={{ gridTemplateColumns: `repeat(${pinFieldNumber}, 1fr)` }}
            className={`pin_field_group`}
          >
            <ReactPinField
              id={pinId}
              ref={pinRef || defaultRef}
              type={`password`}
              autoComplete={!removeAutoComplete ? "off" : ""}
              role="presentation"
              // onKeyDown={onKeyDown}
              onKeyUp={onKeyUp}
              pattern={inputPattern || "[0-9]*"}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              inputMode={inputMode || "numeric"}
              onMouseUp={onMouseUp}
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut}
              length={pinFieldNumber || 6}
              className={`${`pin_field pin_field_${color}`} ${
                completePin && "pin_field_completed"
              }`}
              onChange={(num) => {
                setCompletePin(false);
                if (onChange) onChange(num);
              }}
              onComplete={(num) => {
                if (onComplete) onComplete(num);
                setCompletePin(true);
              }}
              format={(k) => k.toUpperCase()}
              //  disabled={showTime}
              autoFocus
              // ref={ref}
            />
          </div>
          {/* count down start */}
          {showCountDown && (
            <>
              <Countdown
                onFinishClick={countdownFinishClick}
                onFinishLabel={countdownFinishText}
                onFinishLabelClassName={countdownFinishTextClassName}
                labelClassName={countdownLabelClassName}
                templated
                onFinishClassName={countdownFinishClassName}
                reset
                countdownTime={countDownTime}
              />
            </>
          )}

          {/* count down end */}
        </div>
        {/* pin group end */}
      </div>
    );
  }

  if (type === "phone") {
    return (
      <div
        style={style}
        className={`form-group form-group__${color} ${className}`}
      >
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <div className={`input-group input-group__${color} input-group__phone`}>
          <div className={`phone-wrap ${showError && "border-error"}`}>
            <figure className="img-box ">
              <img src={flagIcon} alt="" className="img" />
            </figure>
            <span>+234</span>
            <svg
              className="down-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
            </svg>
          </div>
          <PhoneNumberInput
            type="text"
            className={`form-input form-input_search form-input_${color}`}
            id={id}
            onChange={onChange}
            value={value}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            placeholder={placeholder || "Placeholder Here"}
            name={name}
            {...props}
            // format="### ### ### #"
          />
          <div className="focus-border"></div>
        </div>
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }

  if (type === "textarea") {
    return (
      <div className={`form-group form-group__${color} ${className}`}>
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {/* <div className="input-group"> */}
        <textarea
          cols={textareaColumn || "30"}
          rows={textareaRow || "5"}
          style={{ resize: "unset" }}
          id={id}
          autoComplete={!removeAutoComplete ? "off" : ""}
          role="presentation"
          onChange={(e) => {
            const obj = {
              ...e,
              target: {
                ...e.target,
                name: e.target.name,
                id: e.target.id,
                value: lowerCaseWrap(e.target.value),
              },
            };
            if (capitalize) {
              onChange(obj);
            } else {
              onChange(e);
            }
          }}
          value={value}
          name={name}
          placeholder={placeholder || "Placeholder Here"}
          className={`form-input ${showError && "border-error"}`}
          {...props}
        ></textarea>
        {/* </div> */}
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }

  if (type === "search") {
    return (
      <div className={`form-group form-group__${color} ${className}`}>
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <div
          className={`input-group input-group__${color} input-group__search ${
            showError && "border-error"
          }`}
        >
          <div className="seach-box">
            {" "}
            <figure className="img-box ">
              <img src={searchIcon} alt="" className="img" />
            </figure>
          </div>

          <input
            type="text"
            autoComplete={!removeAutoComplete ? "off" : ""}
            role="presentation"
            className="form-input form-input_search"
            id={id}
            onKeyDown={onKeyDown}
            pattern={inputPattern}
            onKeyUp={onKeyUp}
            onMouseEnter={onMouseEnter}
            inputMode={inputMode || "text"}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            onChange={onChange}
            value={value}
            name={name}
            placeholder={placeholder || "Placeholder Here"}
            {...props}
          />
          <div className="focus-border"></div>
        </div>
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }
  if (type === "date") {
    return (
      <div
        style={style}
        className={`form-group form-group__${color} ${className}`}
      >
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <div className={`wrap ${showError && "border-error"}`}>
          <Flatpicker
            id={id || `cal-${label}`}
            options={
              dateOptions || {
                enableTime: enableTime ? true : false,
                minDate: scheduleFormat && todayDate,
                minuteIncrement: minuteIncrement || 1,
              }
            }
            value={value}
            onChange={(date: any) => {
              onChange(date);
            }}
            name={name}
            className={`form-input input-calender input-calendar-${color}`}
            autoComplete={!removeAutoComplete ? "off" : ""}
            placeholder={placeholder || "Placeholder Here"}
            {...props}
          />
          <label className="label-calendar" htmlFor={id || `cal-${label}`}>
            <figure className="img-box">
              <img src={calendarIcon} alt="" className="img" />
            </figure>
          </label>
        </div>
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }
  if (type === "select") {
    return (
      <div
        style={style}
        className={`form-group form-group__${color} ${className}`}
      >
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <Select
          placeholder={placeholder || "Placeholder Here"}
          styles={selectStyles || reactSelectStyleTable}
          menuIsOpen={selectMenuOpen}
          options={selectOption}
          components={selectComponents}
          onKeyDown={onKeyDown}
          value={value}
          onChange={(e) => onChange && onChange(e)}
          className={`react-select-class ${
            selectValue && "react-select-class-selected"
          }  ${value && "react-select-class-selected"} ${selectClassName} ${
            showError && "border-error"
          }`}
          formatOptionLabel={formatOptionLabel}
          isDisabled={disabled}
          isLoading={loadingSelect}
          isSearchable={searchable}
          isClearable={isClearable}
          isMulti={multi}
          onMenuOpen={onMenuOpen}
          menuPlacement={menuPlacement || `bottom`}
        />
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }
  if (type === "number") {
    return (
      <div
        className={`form-group form-group__${color} ${className}`}
        style={style}
      >
        {label && (
          <label htmlFor={id} className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {/* <div className="input-group"> */}

        <div className="number_input_contain">
          <NumericFormat
            className={`form-input ${showError && "border-error"}`}
            decimalScale={3}
            decimalSeparator="."
            pattern={inputPattern || "[0-9]*"}
            autoComplete={!removeAutoComplete ? "off" : ""}
            role="presentation"
            disabled={disabled}
            type="text"
            thousandsGroupStyle={thousandFormat ? "thousand" : undefined}
            allowNegative
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            inputMode={inputMode || "numeric"}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            prefix={numberPrefix}
            thousandSeparator={thousandFormat && ","}
            placeholder={placeholder || "Placeholder Here"}
            id={id}
            onChange={onChange}
            value={value}
            name={name}
            suffix={numberSuffix}
            {...props}
          />
          {numberSpinner && (
            <figure>
              <img onClick={numberUp} src={chevronUp} alt="" />
              <img onClick={numberDown} src={chevronDown} alt="" />
            </figure>
          )}
        </div>

        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }
  if (type === "password") {
    return (
      <div
        style={style}
        className={`form-group form-group__${color} form-group_password`}
      >
        {label && (
          <label htmlFor="" className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <div
          className={`input-group input-group__${color} ${
            showError && "border-error"
          }`}
        >
          <input
            disabled={disabled}
            autoComplete={!removeAutoComplete ? "off" : ""}
            role="presentation"
            type={showPasword ? "text" : "password"}
            placeholder={placeholder || "Placeholder Here"}
            className={`form-input`}
            id={id}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            onChange={(e) => {
              validatePassword(e.target.value);
              onChange?.(e);
            }}
            value={value}
            name={name}
            onFocus={() => {
              if (showPasswordStrength) setShowGuessBox(true);
              onInputFocus?.();
            }}
            onBlur={() => {
              if (showPasswordStrength) setShowGuessBox(false);
              onInputBlur?.();
            }}
            readOnly={readOnly}
            {...props}
          />
          <div className="focus-border"></div>
          <p
            className={`show-hide show-hide_${showColor} text-${showColor}`}
            onClick={() => setShowPassword(!showPasword)}
          >
            {showPasword ? "Hide" : "Show"}
          </p>
        </div>
        {showError && <p className="error-text">{errorText}</p>}
        {/* password strength box start */}
        {showPasswordStrength && (
          <div className="progress-text-box">
            <div className="progress-box">
              <ProgressBar
                completed={
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) < 20
                    ? 0
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) < 40
                    ? 50
                    : 100
                }
                bgcolor={
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) < 20
                    ? ""
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) >= 20 &&
                      sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) <= 40
                    ? "#FF0F00"
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) > 40 &&
                      sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) <= 80
                    ? "#EA872D"
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) === 100
                    ? "#1ACE37"
                    : ""
                }
              />
              <ProgressBar
                completed={
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) < 40
                    ? 0
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) > 40 &&
                      sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) <= 60
                    ? 50
                    : 100
                }
                bgcolor={
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) <= 40
                    ? ""
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) > 40 &&
                      sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) <= 80
                    ? "#EA872D"
                    : sumValue(
                        validate?.has8digit,
                        validate?.hasCap,
                        validate?.hasLow,
                        validate?.hasNumber,
                        validate?.hasSpecial
                      ) === 100
                    ? "#1ACE37"
                    : ""
                }
              />
              <ProgressBar
                completed={
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) < 100
                    ? 0
                    : 100
                }
                bgcolor={
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) < 100
                    ? ""
                    : "#1ACE37"
                }
              />
            </div>
            <p className="text">
              {sumValue(
                validate?.has8digit,
                validate?.hasCap,
                validate?.hasLow,
                validate?.hasNumber,
                validate?.hasSpecial
              ) === 0
                ? `Password Strength`
                : sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) < 80 &&
                  sumValue(
                    validate?.has8digit,
                    validate?.hasCap,
                    validate?.hasLow,
                    validate?.hasNumber,
                    validate?.hasSpecial
                  ) !== 0
                ? `Weak`
                : `Strong`}
            </p>
          </div>
        )}
        {sumAllNum([
          validate?.has8digit,
          validate?.hasCap,
          validate?.hasLow,
          validate?.hasNumber,
          validate?.hasSpecial,
        ]) !== 100 &&
          showPasswordStrength &&
          showGuessBox && (
            <div className="check-drop-box">
              <div className="top-box">
                <p className="text">Your Password must...</p>
              </div>
              {/* bottom start */}
              <div className="bottom-box">
                {/* check-text box start */}
                <div className="check-text-box">
                  <div
                    className={`check-box ${
                      validate?.hasLow === 20 &&
                      `check-box-active form-group__${strengthColor}`
                    }`}
                  >
                    <FaCheck className="icon" />
                  </div>
                  <p className="text">Include an Lower letter</p>
                </div>
                {/* check-text box end */}
                {/* check-text box start */}
                <div className="check-text-box">
                  <div
                    className={`check-box ${
                      validate?.hasCap === 20 && "check-box-active"
                    }`}
                  >
                    <FaCheck className="icon" />
                  </div>
                  <p className="text">Include an Uppercase letter</p>
                </div>
                {/* check-text box end */}
                {/* check-text box start */}
                <div className="check-text-box">
                  <div
                    className={`check-box ${
                      validate?.hasNumber === 20 && "check-box-active"
                    }`}
                  >
                    <FaCheck className="icon" />
                  </div>
                  <p className="text">Include a Number (0-9)</p>
                </div>
                {/* check-text box end */}
                {/* check-text box start */}
                <div className="check-text-box">
                  <div
                    className={`check-box ${
                      validate?.hasSpecial === 20 && "check-box-active"
                    }`}
                  >
                    <FaCheck className="icon" />
                  </div>
                  <p className="text">A Special character (&%$#@!)</p>
                </div>
                {/* check-text box end */}
                {/* check-text box start */}
                <div className="check-text-box">
                  <div
                    className={`check-box ${
                      validate?.has8digit === 20 && "check-box-active"
                    }`}
                  >
                    <FaCheck className="icon" />
                  </div>
                  <p className="text">Be at least 8 characters</p>
                </div>
                {/* check-text box end */}
              </div>
              {/* bottom end */}
            </div>
          )}
        {/* password strength box end */}
      </div>
    );
  }

  if (type === "range") {
    return (
      <div
        className={`form-group form-group__${color} slider-contain ${className}`}
        style={style}
      >
        {label && (
          <label htmlFor={id} className={"form-label range-label"}>
            {label}{" "}
            {showValue && (
              <span
                style={{ fontWeight: 700, fontSize: "1.4rem" }}
                onClick={onActionClick}
                className={`label-span  text-${labelColor} ${labelClassName}`}
              >
                {range ? range : rangeValue}%{additionalValue}
              </span>
            )}
          </label>
        )}
        {/* <div className="input-group"> */}

        <div className="styled_range">
          <input
            type="range"
            disabled={disabled}
            placeholder={placeholder || "Placeholder Here"}
            className={"track_range"}
            min={min ? min : 0}
            max={max ? max : 100}
            id={id}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            step={rangeStep ? rangeStep : 0.5}
            onChange={handleRangeChange}
            value={range ? range : rangeValue}
          />
          <input
            type="range"
            min={min ? min : 0}
            max={max ? max : 100}
            id={id}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            step={rangeStep ? rangeStep : 0.5}
            value={range ? range : rangeValue}
            onChange={handleRangeChange}
            className="thumb_range"
          />
        </div>
        {/* </div> */}
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }

  if (type === "account-number") {
    return (
      <div
        className={`form-group form-group__${color} ${className}`}
        style={style}
      >
        {label && (
          <label htmlFor={id} className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {/* <div className="input-group"> */}
        <PatternFormat
          className={`form-input ${showError && "border-error"}`}
          disabled={disabled}
          type="text"
          placeholder={placeholder || "Placeholder Here"}
          id={id}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          inputMode={inputMode || "numeric"}
          pattern={inputPattern}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          onChange={onChange}
          value={value}
          format={"#".repeat(maxLength || 10)}
          name={name}
          {...props}
        />
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }

  if (type === "email") {
    return (
      <div
        className={`form-group form-group__${color} ${className}`}
        style={style}
      >
        {label && (
          <label htmlFor={id} className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        {/* <div className="input-group"> */}
        <input
          disabled={disabled}
          type={type}
          placeholder={placeholder || "Placeholder Here"}
          className={`form-input ${showError && "border-error"}`}
          id={id}
          onKeyDown={onKeyDown}
          pattern={inputPattern}
          onKeyUp={onKeyUp}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          inputMode={inputMode || "text"}
          onMouseUp={onMouseUp}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          autoComplete={!removeAutoComplete ? "off" : ""}
          role="presentation"
          onChange={onChange}
          value={value}
          name={name}
          readOnly={readOnly}
          {...props}
        />
        {/* </div> */}
        {showError && <p className="error-text">{errorText}</p>}
      </div>
    );
  }

  if (type === "card_number") {
    return (
      <div
        className={`form-group form-group__${color} ${className}`}
        style={style}
      >
        {" "}
        {label && (
          <label htmlFor={id} className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <div className="card_number">
          <input
            placeholder="0000 0000 0000 0000"
            pattern="[0-9]"
            className={`form-input ${showError && "border-error"}`}
            name="card-number"
            id="card-number"
            maxLength={25}
            autoComplete="cc-number"
            value={value}
            onChange={(e) => {
              setCardType(detectCard(e));
              onChange({
                target: {
                  value: formatCard(e),
                  name: name,
                  id: id,
                },
              });
            }}
          />
          <div
            className={`${cardType === "Verve" ? "card_icon " : `card_icon `} `}
          >
            <figure>
              {cardType === "Mastercard"
                ? icons.mastercard
                : cardType === "Visa"
                ? icons.visa
                : cardType === "Verve"
                ? icons.verve
                : ""}
            </figure>
          </div>
        </div>
      </div>
    );
  }

  if (type === "card-exp") {
    return (
      <div
        className={`form-group form-group__${color} ${className}`}
        style={style}
      >
        {" "}
        {label && (
          <label htmlFor={id} className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <input
          placeholder="MM/YY"
          pattern="[0-9 ]+"
          className={`form-input ${showError && "border-error"}`}
          name="exp"
          id="exp"
          maxLength={5}
          autoComplete="cc-exp"
          value={value}
          onChange={(e) => {
            onChange(handleExpiryDateChange(e));
          }}
        />
      </div>
    );
  }

  if (type === "card-cvv") {
    return (
      <div
        className={`form-group form-group__${color} ${className}`}
        style={style}
      >
        {label && (
          <label htmlFor={id} className="form-label">
            {label}{" "}
            {labelSpanText && (
              <span
                onClick={onActionClick}
                className={`label-span text-${labelColor} ${labelClassName}`}
              >
                {labelSpanText}
              </span>
            )}
          </label>
        )}
        <input
          placeholder="CVV"
          className={`form-input ${showError && "border-error"}`}
          name="cvv"
          id="cvv"
          maxLength={3}
          autoComplete="cc-csc"
          value={value}
          onChange={(e) => {
            onChange(handleCvvChange(e));
          }}
        />
      </div>
    );
  }

  return (
    <div
      className={`form-group form-group__${color} ${className}`}
      style={style}
    >
      {label && (
        <label htmlFor={id} className="form-label">
          {label}{" "}
          {labelSpanText && (
            <span
              onClick={onActionClick}
              className={`label-span text-${labelColor} ${labelClassName}`}
            >
              {labelSpanText}
            </span>
          )}
        </label>
      )}
      {/* <div className="input-group"> */}
      <input
        disabled={disabled}
        type={type}
        placeholder={placeholder || "Placeholder Here"}
        className={`form-input ${showError && "border-error"}`}
        id={id}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        inputMode={inputMode || "text"}
        onMouseUp={onMouseUp}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        autoComplete={!removeAutoComplete ? "off" : ""}
        role="presentation"
        onChange={(e) => {
          const obj = {
            ...e,
            target: {
              ...e.target,
              name: e.target.name,
              id: e.target.id,
              value: lowerCaseWrap(e.target.value),
            },
          };
          if (capitalize) {
            onChange(obj);
          } else {
            onChange(e);
          }
        }}
        value={value}
        name={name}
        readOnly={readOnly}
        {...props}
      />
      {/* </div> */}
      {showError && <p className="error-text">{errorText}</p>}
    </div>
  );
};

export default RazorInputField;

export const lowerCaseWrap = (text?: string) => {
  if (text) {
    // Capitalize the first letter of the first word
    const firstWord = text.split(" ")[0];
    const capitalizedFirstWord =
      firstWord.charAt(0).toUpperCase() + firstWord.slice(1);
    // Reconstruct the string with the capitalized first word
    return capitalizedFirstWord + text.slice(firstWord.length);
  }
  return null;
};
